import React from "react"
import Helpers, { dateFormat, number_format } from "../../../../config/Helpers";
import { latest as API_URL } from "../../../../config/api";

export const api = {
    baseUrl : API_URL + "dynamic-request",
};

export const row_detail = "row-grid reserve-details";

export const row_panel  = "row-grid reserve-panel";

export const _row_reservation = (key_row, reservation, month_reservation, index_aux) => {

    const props = {
        key : `child-${reservation.stay.checkin.date}-${key_row}`,
        className : `${month_reservation.state} column-grid ${(index_aux % 2 ? "row-c " : "")} 
                     ${(month_reservation.state === "inactive" ? "hide" : "")}`
    }
    return(
        <div {...props}>
            <div className={`${row_detail} no`} children={ reservation._id } />
            <div className={`${row_detail} checkin`} children={ dateFormat(reservation.stay.checkin.date) } />
            <div className={`${row_detail} checkout`} children={ dateFormat(reservation.stay.checkout.date) } />
            <div className={`${row_detail} troom`} children={ `T. HAB` } />
            <div className={`${row_detail} agency`} children={ `Agencia` } />
            <div className={`${row_detail} plan`} children={ reservation.plan.name} />
            <div className={`${row_detail} adr`} children={`$ ${ number_format(reservation.tariff_adr,2) } `} />
            <div className={`${row_detail} nights`} children={reservation.nights} />
            <div className={`${row_detail} revenue`} children={`$ ${number_format(reservation.tariff,2)} `} />
        </div>
    )
    return {}
}


// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/reservations/widgets/Reserves.js